import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DropdownToggleDirective } from 'src/app/shared/directives/dropdown-toggle.directive';
import { ErrorHandleService } from 'src/app/shared/services/error-handle/error-handle.service';
import { environment } from 'src/environments/environment';
import { FiltroBuscaService } from '../service/filtro-busca-service/filtro-busca.service';
import { ResultadoFiltroService } from '../service/resultado-service/resultado-filtros.service';

@Component({
  selector: 'app-filtro-busca-salva',
  standalone: true,
  imports: [CommonModule, FormsModule, DropdownToggleDirective],
  templateUrl: './filtro-busca-salva.component.html',
  styleUrls: ['./filtro-busca-salva.component.scss'],
})
export class FiltroBuscaSalvaComponent implements OnInit, OnChanges {
  BASE_IMG_URL: string = environment.BASE_IMG_URL;
  private isInitializing = true;

  idModuloSelecionado: number;

  buscas: any[] = [];

  selectedBuscaId: number = 0;

  @Input() buscaSelecionada: number = 0;
  @Input() disabled: boolean = false;
  @Output() buscaSalvaChange = new EventEmitter<number>();
  @Output() buscaSalvaFiltros = new EventEmitter<any[]>();
  @Input() modoEdicao: boolean = false;

  constructor(
    private readonly _filtroBuscaService: FiltroBuscaService,
    private _errorHandleService: ErrorHandleService,
    private _resultadoFiltroBusca: ResultadoFiltroService,
  ) {}

  ngOnInit() {
    this.buscasSalvas();
    if (this.buscaSelecionada && this.buscaSelecionada > 0) {
      this.selectedBuscaId = this.buscaSelecionada;
    }

    setTimeout(() => {
      this.isInitializing = false;
      if (this.selectedBuscaId > 0 && !this.modoEdicao) {
        this.onBuscaSalvaChange(this.selectedBuscaId);
      }
    }, 0);
  }

  ngOnChanges(changes: any) {
    if (changes.buscaSelecionada) {
      const valorAnterior = this.selectedBuscaId;
      const novoValor = changes.buscaSelecionada.currentValue || 0;
      this.selectedBuscaId = novoValor;
      if (
        !this.isInitializing &&
        novoValor > 0 &&
        novoValor !== valorAnterior &&
        !this.modoEdicao
      ) {
        this.onBuscaSalvaChange(novoValor);
      }
    }

    if (
      changes.idModuloSelecionado &&
      !changes.idModuloSelecionado.firstChange
    ) {
      this.buscasSalvas();
    }
  }

  buscasSalvas(): void {
    this._filtroBuscaService.listaBuscasSalvas().subscribe({
      next: (response) => {
        if (response.success) {
          this.buscas = response.data;
        } else {
          this._errorHandleService.throwConsoleError(response);
        }
      },

      error: (error) => {
        console.error('Erro ao listar buscas salvas:', error);
      },
    });
  }

 onBuscaSalvaChange(buscaId: number, manual: boolean = false) {
  this.buscaSalvaChange.emit(buscaId);

  if (!buscaId || buscaId === 0) return;

  this._resultadoFiltroBusca.getSavedSearchResult(buscaId).subscribe({
    next: (response) => {
      if (response.success && response.data) {
        this.buscaSalvaFiltros.emit({ ...response.data, _manual: manual });
      }
    },
    error: (error) => {
      console.error('Erro ao buscar filtros da busca salva:', error);
    },
  });
}
}
